import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import AutoComplete from '../../../../components/formComponents/autoComplete';
import Input from "../../../../components/formComponents/formInput";
import Radio from "../../../../components/formComponents/formRadio";
import GroupButton from "../../../../components/formComponents/groupButton";
import ModalNoti from '../../../../components/modalNoti';
import ModalTemplate from "../../../../components/modalTemplate";
import { addUser, editUser } from '../../redux/action';
import { autoCompleteDepartment, autoCompleteUser, getListRoleForPermission } from '../../service';

function FormPermission({show, onHide, isEdit, user, changeProject, projects}) {

  const [selectProjectIndex, setSelectProjectIndex] = useState(null);
  const [selectRoleIndex, setSelectRoleIndex] = useState(null);

  const [roles, setRoles] = useState([]);

  const [isShowFailPopUp, setIsShowFailPopUp] = useState(false);

  const dispatch = useDispatch();

  const [
    isAddingUser,
    isAddedUserSuccess,
    isAddedUserFail,

    isEditingUser,
    isEditedUserSuccess,
    isEditedUserFail,
  ] = useSelector((state) => [
    state.manageUser.isAddingUser,
    state.manageUser.isAddedUserSuccess,
    state.manageUser.isAddedUserFail,

    state.manageUser.isEditingUser,
    state.manageUser.isEditedUserSuccess,
    state.manageUser.isEditedUserFail,
  ]);

  useEffect(() => {
		if(isAddedUserFail || isEditedUserFail){
			setIsShowFailPopUp(true);
		}

	},[isAddedUserFail, isEditedUserFail])

  useEffect(() => {
    if(user && isEdit){
      const index1 = projects.findIndex((project) => project.account_name.toLowerCase() === user.project.toLowerCase());
      if(index1 !== -1){
        setSelectProjectIndex(index1);
      };   
    } else {
      setSelectProjectIndex(null);
    }
  },[user, isEdit]);

  useEffect(() => {
    if(isEdit) {
      if(isEditedUserSuccess) {
        handleReset();
        // changeProject(projects[selectProjectIndex].account_name);
        setSelectProjectIndex(null);
        setSelectRoleIndex(null);
        onHide();
      }
    } else {
      if(isAddedUserSuccess) {
        handleReset();
        changeProject(projects[selectProjectIndex].account_name);
        setSelectProjectIndex(null);
        setSelectRoleIndex(null);
        onHide();
      }
    }
  },[isAddedUserSuccess, isEditedUserSuccess]);

  const initRoles = async (apiKey) => {
    let {success, data} = await getListRoleForPermission(apiKey);
    return data;
  };

  useEffect(() => {
    if(selectProjectIndex !== null) {
      initRoles(projects[selectProjectIndex].api_key).then((ressult) => {
        setRoles(ressult);
      })
    }
  },[selectProjectIndex]);

  useEffect(() => {
    if(roles.length !== 0) {
      if(user && isEdit) {
        const index2 = roles.findIndex((rl) => rl.role_name.toLowerCase() === user.role.toLowerCase());
        if(index2 !== -1){
          setSelectRoleIndex(index2);
        } else {
          setSelectRoleIndex(undefined);
        }
      } else {
        setSelectRoleIndex(0);
      }
    } 
  }, [roles, user, isEdit])

  useEffect(() => {
    if(!isEdit) {
      setRoles([]);
      setSelectRoleIndex(null);
      setSelectProjectIndex(null);
    }
  },[isEdit])

  const capitalize = (input) => {  
    return input.toLowerCase().replace(/\s+/g,' ').trim().split(' ').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');  
  } 

  const clearSpace = (input) => {
    return input.replace(/\s+/g,' ').trim()
  }

  const permissionValidationSchema = yup.object().shape({
    email: yup
      .string()
      .email('Email không đúng định dạng. Vui lòng kiểm tra lại.')
      .required('Vui lòng nhập email.')
      .test('server', 'Email không đúng định dạng. Vui lòng kiểm tra lại.', val => (val && val.toLowerCase().split('@').pop() === 'fpt.com.vn'|| val && val.toLowerCase().split('@').pop() === 'fpt.com')),
    name: yup.string().required('Vui lòng nhập Tên nhân viên.'),
    phone: yup
      .string()
      .test('len', 'SDT phải có 5 hoặc 10 số.', val => (val === null || val === undefined || val.length === 5 || val.length === 10))
      .required('Vui lòng nhập SDT nhân viên.'),
    department: yup.string().required('Vui lòng nhập Bộ phận.'),
  });

  const onCreateOrUpdate = (data) => {
    if(isEdit) {
      dispatch(editUser({
        ...data,
        email: data.email.toLowerCase(),
        name: capitalize(data.name),
        department: clearSpace(data.department.toUpperCase()),
        project: projects[selectProjectIndex],
        role: selectProjectIndex ? roles[selectRoleIndex].role_code : roles[0].role_code,
      })); 
    } else {
      dispatch(addUser({
        ...data,
        email: data.email.toLowerCase(),
        name: capitalize(data.name),
        department: clearSpace(data.department.toUpperCase()),
        project: projects[selectProjectIndex],
        role: roles[selectRoleIndex].role_code,
      })); 
    }
  }

  const {
    values,
    errors,
    touched,
    isValid,
    handleChange,
    handleBlur,
    handleSubmit,
    handleReset,
    setFieldValue,
    setTouched,
  } = useFormik({
    validateOnMount: true,
    enableReinitialize: true,
    initialValues: {
      email: isEdit ? user.email : '',
      name: isEdit ? user.name : '',
      phone: isEdit ? user.phone: '',
      department: isEdit ? user.department : '',
    },
    validationSchema: permissionValidationSchema,
    onSubmit: onCreateOrUpdate,
  });

  const displayError = () => {
    if(errors.email && touched.email) {
      return errors.email;
    }

    if(errors.name && touched.name) {
      return errors.name;
    }

    if(errors.phone && touched.phone) {
      return errors.phone;
    }

    if(errors.department && touched.department) {
      return errors.department;
    }

    if(touched.department && selectProjectIndex === null) {
      return "Vui lòng chọn Dự án tham gia";
    }

    if(touched.department && selectRoleIndex === null) {
      return "Vui lòng chọn Vai trò trong dự án";
    }
  }

  /*Handle auto complete email*/
  const [dataCompleteEmail, setDataCompleteEmail] = useState([]);

  useEffect(() => {
    if(values.email !== '') {
      autoCompleteUser(values.email).then(({success, data}) => {
        setDataCompleteEmail([...data]);
      })
    } else {
      setDataCompleteEmail([]);
    }
  }, [values.email]);

  const handleSelectEmailAutoComplete = async (index) => {
    await setFieldValue('email', dataCompleteEmail[index].email);
    await setTouched({
      ...touched,
      email: true,
    });
    await setFieldValue('name', dataCompleteEmail[index].fullName);
    await setTouched({
      ...touched,
      name: true,
    });
    await setFieldValue('phone', dataCompleteEmail[index].sdt);
    await setTouched({
      ...touched,
      phone: true,
    });
    await setFieldValue('department', dataCompleteEmail[index].department ? dataCompleteEmail[index].department : '');
    await setTouched({
      ...touched,
      department: true,
    });
    setDataCompleteEmail([]);
  }

  /*Handle auto complete for department*/
  const [dataCompleteDepartment, setDataCompleteDepartment] = useState([]);

  useEffect(() => {
    if(values.department !== '') {
      autoCompleteDepartment(values.department).then(({success, data}) => {
        if(data.department_list?.length > 10) {
          setDataCompleteDepartment(data.department_list?.slice(0, 10));
        } else {
          setDataCompleteDepartment(data.department_list);
        }
      })
    } else {
      setDataCompleteDepartment([]);
    }
  }, [values.department]);

  const handleSelectDepartmentAutoComplete = async (index) => {
    await setFieldValue('department', dataCompleteDepartment[index]);
    await setTouched({
      ...touched,
      department: true,
    });
    setDataCompleteDepartment([]);
  }

  return(
    <>
      <ModalTemplate show={show} onHide={onHide} title={isEdit ? "Cập nhật quyền project" : "Phân quyền project"}>
        <div className="row pt-2">
          <AutoComplete 
            classInput={isEdit ? 'col-lg-6 col-md-12 is_edit' : 'col-lg-6 col-md-12'}
            label='Email nhân viên'
            placeholder='example@fpt.com'
            required={true}
            disabled={isEdit}
            value={values.email}
            isError={errors.email && touched.email}
            onChange={handleChange('email')}
            onBlur={handleBlur('email')}
            autoComplete={dataCompleteEmail.length === 0 ? [] : dataCompleteEmail.map((e) => e.email)}
            onClick={handleSelectEmailAutoComplete}
          ></AutoComplete>
          <Input 
            classInput='col-lg-6 col-md-12'
            label='Tên nhân viên'
            placeholder='Nhập tên nhân viên'
            required={true}
            value={values.name}
            isError={errors.name && touched.name}
            onChange={(e) => {
              if(e.target.value.replace(/\s/g, '') !== '') {
                let temp = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                setFieldValue('name', temp);
              } else {
                setFieldValue('name', '');
              }
            }}
            onBlur={handleBlur('name')}
          ></Input>
        </div>
        <div className="row pt-5">
          <Input 
            classInput='col-lg-6 col-md-12' 
            label='SDT nhân viên'
            placeholder='Nhập SDT nhân viên'
            required={true}
            value={values.phone}
            isError={errors.phone && touched.phone}
            onBlur={handleBlur('phone')}
            onChange={(e) => {
              let temp = e.target.value.replace(/[^0-9]/g, '');
              if(temp.length <= 10) {
                setFieldValue('phone', temp);
              } else {
                setFieldValue('phone', temp.substring(0, 10));
              }        
            }}
          ></Input>
          <AutoComplete 
             classInput='col-lg-6 col-md-12'
             label='Bộ phận'
             placeholder='Nhập bộ phận'
             required={true}
             value={values.department}
             isError={errors.department && touched.department}
             onChange={(e) => {
              if(e.target.value.replace(/\s/g, '') !== '')  {
                let temp = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                setFieldValue('department', temp);
              } else {
                setFieldValue('department', '');
              }
             }}
             onBlur={handleBlur('department')}
            autoComplete={dataCompleteDepartment}
            onClick={handleSelectDepartmentAutoComplete}
          ></AutoComplete>
        </div>
        <div className="row pt-5">
          {isEdit ? 
          <Input 
            classInput='col-lg-6 col-md-12 mt-1' 
            label='Dự án tham gia' 
            placeholder='Chọn dự án'
            required={true}
            value={selectProjectIndex !== null ? projects[selectProjectIndex].account_name : ''}
            disabled={true}
            onChange={()=> {}}
            onBlur={() => {}}
          ></Input> :
          <Radio 
            classRadio='col-lg-6 col-md-12' 
            label='Dự án tham gia' 
            data={projects.map((pr) => pr.account_name)} 
            selectDataIndex={selectProjectIndex} 
            handleSelect={(index) => setSelectProjectIndex(index)} 
            required={true} 
            placeholder='Chọn dự án'>
          </Radio>
          }
          <Radio 
            classRadio='col-lg-6 col-md-12' 
            label='Vai trò trong dự án' 
            placeholder={selectRoleIndex === undefined ? user?.role : 'Chọn vai trò'}
            data={roles.map(role => role.role_name)} 
            selectDataIndex={selectRoleIndex} 
            handleSelect={(index) => setSelectRoleIndex(index)} 
            required={true} 
            >
          </Radio>
        </div>
        <div className="noti_report">
          {displayError()}
        </div>
        <GroupButton
          leftButton={{
            onClick: () => {
              onHide();
            },
            content: 'Đóng',
            disabled: false,
          }}
          rightButton={{
            onClick: () => {
              handleSubmit();
            },
            content: isEdit ? 'Cập nhật' : 'Thêm mới',
            disabled: !isValid || isAddingUser || isEditingUser || selectProjectIndex === null || selectRoleIndex === null,
          }}
        ></GroupButton>
      </ModalTemplate>

      <ModalNoti
				show={isShowFailPopUp}
				onHide={() => setIsShowFailPopUp(false)}
				closeButton={false}
				content={"Xảy ra lỗi trong quá trình xử lý. Vui lòng thao tác lại"}
				leftButton={{
					onClick: () => {
						setIsShowFailPopUp(false);
					},
					content: "Đóng"
				}}
				rightButton={{
					onClick: () => {
						setIsShowFailPopUp(false);
						handleSubmit();
					},
					content: "Thử lại"
				}}
			>
			</ModalNoti>
  </>
  );
}

export default FormPermission;